import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../service/auth.service';
import { CustomerService } from '../service/customer.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'login-init',
  templateUrl: './login.component.html'
})
export class LoginInitComponent implements OnInit {

  loginForm: FormGroup;
  submitted_login = false;
  registerForm: FormGroup;
  submitted_register = false;
  showRegister = false;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private authenService: AuthService,
    private customerService: CustomerService
  ) {
    this.loginForm = fb.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required],
    });
    this.registerForm = fb.group({
      'customer_name': ['', Validators.required],
      'email': ['', [Validators.required, Validators.email]],
      'tel_no': ['', Validators.required],
      'company': ['']
    });
   }

  ngOnInit() {
  } 

  login(value){ 
    this.spinner.show();
    console.log(value);
    this.submitted_login = true;
    if(this.loginForm.invalid){
      return;
    }
    let param = {'username':value['username'],'password':value['password']};
    this.authenService.auth(param).subscribe(res=>{
        console.log(res.data);
        this.authenService.setCustomer(res.data);
        setTimeout(() => {this.spinner.hide();}, 100);
    }, er => {
      if(er.error.code == "customer_not_active"){
        this.failDialog("","Account not active");
      }else{
        this.failDialog("","Invalid Username and Password");
      }
      this.spinner.hide();
      console.log(er);
    });
  }

  openModelCreate()
  {
    this.showRegister = true;
    this.submitted_register = false
    this.registerForm.patchValue({
      customer_name: '',
      email: '',
      tel_no: '',
    });
    $('#modal-create').modal('show');
  }

  register(){
    this.submitted_register = true
    if(!this.registerForm.valid){
      return;
    }
    this.spinner.show();
    this.customerService.register(this.registerForm.value).subscribe((res) => {
      console.log(res);
      this.spinner.hide();
      Swal.fire("สมัครสมาชิกสำเร็จแล้ว", "ทางเราจะติดต่อคุณเพื่อยืนยันการสมัครสมาชิก", "success");
      this.submitted_register = false;
      this.showRegister = false;
      this.registerForm.reset();
    }, error => {
      this.spinner.hide();
      console.error(error);
      this.failDialog('เกิดข้อผิดพลาด','ไม่สามารถบันทึกข้อมูลได้');
    });
  }

  successDialog(){
    Swal.fire("ทำรายการสำเร็จ!", "", "success");
  }

  failDialog(title,msg){
    Swal.fire({
      type: 'error',
      title: title,
      text: msg
    })
  }

}
